// jrs-v2-beacon-post.js — D-0 review (Bug J transport).
//
// Reliable unload write to a SAME-ORIGIN Shopify cart endpoint (/cart/update.js,
// /cart/change.js). On WebKit/Safari — the browser all 10 defective orders ran on —
// fetch({keepalive:true}) does NOT initiate during the same-tick redirect (no Network
// request, no console error; the throw is swallowed). navigator.sendBeacon is the only
// transport that survives unload there. This mirrors the analytics beacon already in the
// stack (jrs-v2-customizer-popup.js `_fireAnalyticsBeacon`): an application/json Blob so
// Shopify parses the JSON body (same-origin => no CORS preflight, so application/json is fine).
//
// Returns true iff the beacon was queued — the caller falls back to fetch otherwise.
// Never throws. ES5 / IIFE / window.JRS, consistent with the rest of the v2 stack.
//
// Used by: betterconversions-bundle.js doRedirect (bundle parent _bundle_debug_log property),
// betterconversions-customizer.js persistDebugLogToCart (_regular_product_debug_log property).
// Unit-tested directly in __tests__/jrs-v2-beacon-post.test.js.
(function () {
  window.JRS = window.JRS || {};
  if (window.JRS.beaconPost) { return; }

  function beaconPost(url, bodyStr) {
    try {
      if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
        var blob;
        try { blob = new Blob([bodyStr], { type: 'application/json' }); }
        catch (be) { blob = bodyStr; } // very old engines without Blob: hand the raw string
        return navigator.sendBeacon(url, blob) === true;
      }
    } catch (e) { /* fall through — caller will use fetch */ }
    return false;
  }

  window.JRS.beaconPost = beaconPost;
})();
